////http://codepen.io/lukejacksonn/pen/PwmwWV

var $nav = $('.nav .main-navigation');
var $btn = $('.header .toggle');
var $vlinks = $('.header .primary-nav');
var $hlinks = $('.header .hidden-links');
var breaks = [];

function updateNav() {
  if (window.matchMedia("(max-width: 950px)").matches) {
    $vlinks.children(':gt(0)').appendTo($hlinks);
    $btn.removeClass('hidden');
    $hlinks.removeClass('hidden');
  } else {
    $hlinks.children().appendTo($vlinks);
    $btn.addClass('hidden');
    $hlinks.addClass('hidden');
  }
}

updateNav();

(function($) {
	$(function(){
	setTimeout(function(){
			updateNav();
		}, 100);
		$(window).resize(function() {
			updateNav();

			if( $('.toggle').hasClass('hidden') ) {
				$('.menu, .overlay').removeClass('open');
				$('body').removeClass('menu-open');
			}
		});

		$('.toggle, .body-overlay').on('click', function(){
			$('.secondary-nav, .body-overlay, .hidden-links').toggleClass('show');
			$('body').toggleClass('menu-open');
			updateNav();
		});

		// $(window).on('load', function(){ // jquery 3.6.0
		$(window).load(function(){
			function getScroll() {
				var b = document.body;
				var e = document.documentElement;
				return {
					left: parseFloat( window.pageXOffset || b.scrollLeft || e.scrollLeft ),
					top: parseFloat( window.pageYOffset || b.scrollTop || e.scrollTop )
				};
			}

			if( ( $('.basic-page').length || $('.sticky-side-bar').length ) && $('.the-content').length) {
				var minHeight = $('.sticky-side-bar').height();

				if (!$('.sticky-side-bar').hasClass('heightBypass')) {
					$('.primary-content .the-content').css({
						'minHeight' : minHeight + 24
					});
				}


				var myHeader = $('.the-content').last();
				myHeader.data( 'position', myHeader.position() );

				$(window).scroll(function() {
					var hPos = myHeader.data('position'), scroll = getScroll();
					if ( hPos.top < scroll.top ){
						$('.sticky-side-bar').addClass('fixed');
					}
					else {
						$('.sticky-side-bar').removeClass('fixed');
					}
				});

				$(window).resize(function() {

					myHeader.data( 'position', myHeader.position() );
					var hPos = myHeader.data('position'), scroll = getScroll();
					if ( hPos.top < scroll.top ){
						$('.sticky-side-bar').addClass('fixed');
					}
					else {
						$('.sticky-side-bar').removeClass('fixed');
					}
				});
			}

			if( $('.sub-header-callout').length && $('.the-content').length ) {
				var minHeight2 = $('.sub-header-callout .action-button').height();
				$('.primary-content .the-content').css({
					'minHeight' : minHeight2 + 24,
				});

				var myHeader2 = $('.the-content').last();
				myHeader2.data( 'position', myHeader.position() );

				$(window).scroll(function() {
					var hPos = myHeader2.data('position'), scroll = getScroll();
					if ( hPos.top < scroll.top + minHeight2 + 64){
						$('.sub-header-callout').addClass('fixed');
						$('.primary-content .the-content').css({
							'paddingTop' : minHeight2 + 64
						});
					}
					else {
						$('.sub-header-callout').removeClass('fixed');
						$('.primary-content .the-content').css({
							'paddingTop' : 0
						});
					}
				});

				$(window).resize(function() {
					minHeight2 = $('.sub-header-callout .action-button').height();
					myHeader2.data( 'position', myHeader.position() );
					var hPos = myHeader2.data('position'), scroll = getScroll();
					if ( hPos.top < scroll.top + minHeight2 + 64){
						$('.sub-header-callout').addClass('fixed');
						$('.primary-content .the-content').css({
							'paddingTop' : minHeight2 + 64
						});
					}
					else {
						$('.sub-header-callout').removeClass('fixed');
						$('.primary-content .the-content').css({
							'paddingTop' : 0
						});
					}
				});
			}
		});

		$('.toggle-search').on('click', function(){
			$('.header-search-container .search').toggleClass('show-search');
		});

		setTimeout(function(){
			$('.faq h3').first().trigger('click');
		}, 50);


		$('.faq h3').on('click', function() {
			$(this).next().slideToggle();
			$(this).parents('.faq').toggleClass('open');
		});
	});
})(jQuery);

$('document').ready(function(){

    // wraps scrollable tables on medium and smaller viewports
    function scrollWrap() {
        $('table, .table-flex').wrap('<div class="scroll-wrapper"></div>');
        $('.scroll-wrapper').before( '<div class="scroll-header">Swipe to view more content</div>' );
    }
    scrollWrap();

    // show or hide table scroll header based on if overflowing its parent
    function handleScrollResize() {
        $('table, .table-flex').each(function(index) {
            var table = $(this);
            var tableWidth = table.outerWidth();
            var parentWidth = table.parent().outerWidth();
            var scrollHeader = table.parent().prevAll('.scroll-header:first');

            if (tableWidth > parentWidth) {
                // element has overflow
                scrollHeader.show();
                table.parent().addClass('state-overflow');
            } else {
                // element doesn't overflow
                scrollHeader.hide();
                table.parent().removeClass('state-overflow');
            }
        })
    }
    $(window).on("resize",function () {
        handleScrollResize();
    });
    $(document).ready( function () {
        handleScrollResize();
    });

});